import { isNonEmptyArray, isObjectWithKey } from "@cayuse/shared-react.utils.type-checks";
import { hydrateColumnHeaders } from "utils/shell";
import {
	AWARDS_LIST_DEFAULT_COLUMNS,
	COLUMN_HEADER_KEYS,
	PROJECT_MAIN_VIEW_LIST_DEFAULT_COLUMNS,
	PROPOSAL_MAIN_VIEW_LIST_DEFAULT_COLUMNS,
} from "globals/constants";


const emptyResult = [];

const getColumns = (type, formColumnHeaders) => {
	return isObjectWithKey(formColumnHeaders, type)
		? formColumnHeaders[type]
		: emptyResult;
}

const getColumnHeaders = (type, {
	formColumnHeaders,
	defaultColumnHeaders: incomingDefaultColumnHeaders
} = {}) => {
	const availableColumns = getColumns(type, formColumnHeaders);

	const hasColumnHeaders = isNonEmptyArray(availableColumns);
	const hasDefaultColumnHeaders = isNonEmptyArray(incomingDefaultColumnHeaders);

	const defaultColumnHeaders = hasColumnHeaders && hasDefaultColumnHeaders
		? hydrateColumnHeaders(incomingDefaultColumnHeaders, availableColumns)
		: incomingDefaultColumnHeaders || [];

	return {
		availableColumns,
		defaultColumnHeaders,
	};
};

export const getProposalListAvailableColumns = (formColumnHeaders) => getColumnHeaders(
	COLUMN_HEADER_KEYS.PROPOSAL,
	{ defaultColumnHeaders: PROPOSAL_MAIN_VIEW_LIST_DEFAULT_COLUMNS, formColumnHeaders },
);

export const getAwardListAvailableColumns = (formColumnHeaders) => getColumnHeaders(
	COLUMN_HEADER_KEYS.AWARD,
	{ defaultColumnHeaders: AWARDS_LIST_DEFAULT_COLUMNS, formColumnHeaders },
);

export const getProjectListAvailableColumns = (formColumnHeaders) => getColumnHeaders(
	COLUMN_HEADER_KEYS.PROJECT,
	{ defaultColumnHeaders: PROJECT_MAIN_VIEW_LIST_DEFAULT_COLUMNS, formColumnHeaders },
);
